import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabsPage } from './tabs-page/tabs.page';
import { ChecklistComponent } from './checklist/checklist.component';
import { OrganisationComponent } from './organisation/organisation.component';
import { AddressComponent } from './address/address.component';
import { PartiesComponent } from './parties/parties.component';
import { RiskComponent } from './risk/risk.component';
import { DeclarationComponent } from './declaration/declaration.component';
import { FaqComponent } from './faq/faq.component';

const routes: Routes = [
  {
    path: 'page',
    component: TabsPage,
    children: [
      {
        path: '',
        redirectTo: '/page/checklist',
        pathMatch: 'full'
      },
      {
        path: 'checklist',
        component: ChecklistComponent
      },
      {
        path: 'organisation',
        component: OrganisationComponent
      },
      {
        path: 'address',
        component: AddressComponent
      },
      {
        path: 'parties',
        component: PartiesComponent
      },
      {
        path: 'risk',
        component: RiskComponent
      },
      {
        path: 'declaration',
        component: DeclarationComponent
      },
      {
        path: 'faq',
        component: FaqComponent
      },
    ]
  },
  {
    path: '',
    redirectTo: '/page/checklist',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class PageRoutingModule {}
